import {
  Http
} from '@/model/Http.js'

export default class member extends Http {
  //会员列表
  getUserList(data) {
    const url = 'api/open/user/search'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }

  //会员详情
  getUserInfo(data) {
    const url = 'api/user/get'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/kfc/member.js